module.exports = __webpack_public_path__ + "static/media/multiple-choice-letters-sun.b382e5cf.svg";